// extracted by mini-css-extract-plugin
export var dark = "navigation-module--dark--87964";
export var end = "navigation-module--end--73262";
export var fix = "navigation-module--fix--7b4aa";
export var header = "navigation-module--header--a12e5";
export var home = "navigation-module--home--c5237";
export var menu = "navigation-module--menu--214ee";
export var nav = "navigation-module--nav--9d614";
export var start = "navigation-module--start--4c202";
export var tertiary = "navigation-module--tertiary--3e3ea";